import { SwipeableDrawer, Box } from "@mui/material";
import React, { useState } from "react";
import Util from "../../Util";
import Close from "../../assets/Icon/close.png";

const UTMSource = (props) => {
  const getLanguage = Util.getSelectedLanguage();
  const show = props.show;
  const onClose = props.onClose;
  const userData = props.userData;
  const [isStateUpdated, setIsStateUpdated] = useState(false);
  const [alertModal, setIsAlertModal] = useState(false);
  return (
    <div>
      <SwipeableDrawer
        anchor={getLanguage === "ar" ? "left" : "right"}
        open={show}
        onClose={() => {
          if (isStateUpdated) {
            setIsAlertModal(true);
          } else {
            onClose();
            // reset();
            setIsStateUpdated(false);
          }
        }}
        onOpen={() => {}}
      >
        <Box sx={{ width: "656px", padding: "20px" }} role="presentation">
          <div className="d-flex align-items-center justify-content-between">
            <div className="drawer-header">UTM Source</div>

            <button className="hidden-btn">
              <img
                src={Close}
                alt="Close"
                className="svg-icon"
                onClick={() => {
                  if (isStateUpdated) {
                    setIsAlertModal(true);
                  } else {
                    onClose();
                    setIsStateUpdated(false);
                  }
                }}
                height={20}
                width={20}
              />
            </button>
          </div>
          <hr style={{ backgroundColor: "#E5E7EB" }} />
          <div className="mt-4">
            <span>{userData?.email}</span> : 
            <span><b>{userData?.utmSources[0]?.utm_source}</b></span>
          </div>
        </Box>
      </SwipeableDrawer>
    </div>
  );
};

export default UTMSource;
